import {Route, Navigate} from 'react-router-dom';
import {PricingPage} from './pricing-table/pricing-page';
import React, {Fragment} from 'react';
import {FullPageLoader} from '../ui/progress/full-page-loader';
import {useAuth} from '@common/auth/use-auth';

const BillingPageRoutes = React.lazy(
  () => import('./billing-page/billing-page-routes')
);

const CheckoutRoutes = React.lazy(() => import('./checkout/checkout-routes'));

function SubscriptionRedirect() {
  const {isSubscribed} = useAuth();
  return isSubscribed ? <Navigate to="/billing" /> : <PricingPage />;
}

export const BillingRoutes = (
  <Fragment>
    <Route path="/pricing" element={<SubscriptionRedirect />} />
    <Route
      path="checkout/*"
      element={
        <React.Suspense fallback={<FullPageLoader screen />}>
          <CheckoutRoutes />
        </React.Suspense>
      }
    />
    <Route
      path="billing/*"
      element={
        <React.Suspense fallback={<FullPageLoader screen />}>
          <BillingPageRoutes />
        </React.Suspense>
      }
    />
  </Fragment>
);
